import { render, staticRenderFns } from "./DashboardTables.vue?vue&type=template&id=149451a9&"
import script from "./DashboardTables.vue?vue&type=script&lang=js&"
export * from "./DashboardTables.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTables.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports